<script setup lang="ts">
import AppsButtons from '@/components/AppsPage/AppsButtons.vue'
import AppsPhones from '@/components/AppsPage/AppsPhones.vue'
import AppsQrCode from '@/components/AppsPage/AppsQrCode.vue'
import AppsSocialNetworks from '@/components/AppsPage/AppsSocialNetworks.vue'
import AppsTitle from '@/components/AppsPage/AppsTitle.vue'

const { isDesktop } = useResponsive()

definePageMeta({
  middleware: [
    function () {
      // При заходе на страницу с мобильного устройства система должна понимать платформу девайса и переводить в store с использованием ссылки

      const { isDesktop } = useResponsive()
      const { isAndroid, isIos } = useDevice()

      if (isDesktop.value) return

      switch (true) {
        case isAndroid:
          navigateTo(
            'https://redirect.appmetrica.yandex.com/serve/170404690310291845',
            {
              external: true,
            },
          )
          break

        case isIos:
          navigateTo(
            'https://redirect.appmetrica.yandex.com/serve/818922990581394302',
            {
              external: true,
            },
          )
          break

        default: // Huawei
          navigateTo(
            'https://redirect.appmetrica.yandex.com/serve/821010311468352718',
            {
              external: true,
            },
          )
          break
      }
    },
  ],
})

const { $host } = useNuxtApp()
const route = useRoute()

const title = 'Приложение для заказа вкусной еды от ресторана «Фарфор»'
const description =
  'Скачать приложение ресторана «Фарфор» для заказа вкусной еды с доставкой по России, Казахстану и Кыргызстану. Бесплатно для скачивания в AppStore, GooglePlay и AppGallery.'

useHead({
  title,
  ...SEOMaker(
    $host,
    {
      title,
      keywords: '',
      description,
    },
    route.fullPath,
    route.path,
  ),
})
</script>

<template>
  <div class="apps-page">
    <div class="apps-page__info">
      <apps-title class="apps-page__title-component" />
      <apps-buttons class="apps-page__buttons-component" />
      <apps-social-networks />
    </div>

    <div class="apps-page__phones-container">
      <apps-phones class="apps-page__phones" />
      <apps-qr-code v-if="isDesktop" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.apps-page {
  position: relative;
  display: grid;
  flex: 1;
  grid-template-columns: 1fr 1fr;
  padding-top: 40px;
  padding-bottom: 90px;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    content: '';
    background-image: url('/assets/images/apps-page/background-heart-desktop.svg');
    background-position: right -165px top 60px;
    background-size: 125%;
  }

  &__info {
    z-index: 1;
  }

  &__title-component {
    margin-top: 117px;
  }

  &__buttons-component {
    margin-top: 64px;
    margin-bottom: 78px;
  }

  &__phones-container {
    z-index: 1;
    display: grid;
    grid-template-columns: minmax(1px, 372px) max-content;
    gap: 80px;
  }

  &__phones {
    margin-top: 83px;
  }

  @include media('>tablet', '<desktop') {
    &::before {
      background-position: right -105px top 70px;
      background-size: 120%;
    }
  }

  @include media('<desktop-mini') {
    display: flex;
    flex-direction: column-reverse;
    padding: 0 20px 80px;

    &::before {
      background-image: url('/assets/images/apps-page/background-heart-mobile.svg');
      background-position: left 5px top 35px;
      background-size: 100%;
    }

    &__phones-container {
      display: flex;
      justify-content: center;
    }

    &__phones {
      width: 100%;
      max-width: 382px;
    }

    &__title-component {
      margin-top: 120px;
    }

    &__buttons-component {
      margin-top: 0 64px;
    }
  }

  @include media('<tablet') {
    padding-bottom: 40px;

    &::before {
      background-position: left -25px top 30px;
      background-size: 120%;
    }

    &__phones {
      margin-top: 49px;
    }

    &__title-component {
      margin-top: 0;
    }

    &__buttons-component {
      margin-top: 32px;
      margin-bottom: 40px;
    }
  }
}
</style>
